export function getSongDuration(src: string) {
  return new Promise((resolve: (value: number) => void) => {
    const audio = new Audio();
    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration);
    });
    audio.src = src;
  });
}
